import React from 'react';
import ErrorState from 'components/ErrorState';

interface EmptyErrorStateProps {
  availableCategoriesCount: number;
  error?: string;
  validUserCategories?: string[];
  onRetry?: () => void;
}

// Empty State / Error State
const EmptyErrorState: React.FC<EmptyErrorStateProps> = ({
  availableCategoriesCount,
  error,
  validUserCategories,
  onRetry,
}) => {
  if (availableCategoriesCount > 0 && !error) return null;

  return (
    <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden">
      {error ? (
        <div className="flex items-center justify-center min-h-[400px]">
          {error.includes('have been completed') ? (
            <div className="text-center max-w-md mx-auto p-8">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-2xl">🎉</span>
              </div>
              <h3 className="text-xl font-baijamjuree font-bold text-gray-900 mb-3">
                Excellent Work!
              </h3>
              <p className="text-gray-700 mb-6 font-baijamjuree">
                You have completed all qualification evaluations for the{' '}
                <strong>{(validUserCategories || []).join(', ')}</strong>{' '}
                {(validUserCategories || []).length > 1
                  ? 'categories'
                  : 'category'}
                .
              </p>
            </div>
          ) : (
            <div className="p-8 w-full">
              <ErrorState
                title="No Submissions Available"
                error={error}
                onRetry={onRetry}
              />
            </div>
          )}
        </div>
      ) : (
        <div className="p-12 text-center">
          <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg
              className="w-8 h-8 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
              />
            </svg>
          </div>
          <h3 className="text-lg font-baijamjuree font-bold text-gray-900 mb-2">
            No Finalists Found
          </h3>
          <p className="text-gray-600 font-baijamjuree">
            No final submissions available for evaluation.
          </p>
        </div>
      )}
    </div>
  );
};

export default EmptyErrorState;
